import React from 'react';
import MuiCardContent, { CardContentProps as MuiCardContentProps } from '@mui/material/CardContent';

export interface CardContentProps extends MuiCardContentProps {}

const CardContent = React.forwardRef<React.ComponentRef<typeof MuiCardContent>, CardContentProps>(
  function CardContent(props, ref) {
    return <MuiCardContent ref={ref} {...props} />;
  },
);

export default CardContent;
